import { render, staticRenderFns } from "./wangeditor.vue?vue&type=template&id=19fe984a&"
import script from "./wangeditor.vue?vue&type=script&lang=js&"
export * from "./wangeditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports